export const MESSENGER_URL = 'https://m.me/infina.vn?ref=webchat'
export const SOCIAL_URL = {
  ZALO_URL: 'https://zalo.me/2664544553222201336',
  MESSENGER_URL: 'https://m.me/infina.vn?ref=webchat',
  CALENDAR_URL: 'https://calendly.com/infina',
}
export const DOWNLOAD = {
  APP_STORE: 'https://apps.apple.com/us/app/id1504177263',
  GOOGLE_STORE: 'https://play.google.com/store/apps/details?id=com.realstake',
}
export const DATE_FORMAT = {
  DAY: 'DD/MM/YYYY',
}
export const SESSION_STORAGE_KEY = {
  AUTO: 'auto',
  HIDE: 'hide',
}
export const LOCAL_STORAGE_KEY = {
  LANG: 'i18nextLng',
  AUTH: 'authenticated',
  TOKEN: 'authenticated_token',
  REFER: 'refer',
  ONESIGNAL: 'onesignal',
}

export const LANGUAGES = {
  en: {
    name: 'English',
    countryCode: 'en_US',
  },
  vi: {
    name: 'Tiếng Việt',
    countryCode: 'vi_VN',
  },
}

export const COUNTRY_OPTIONS = {
  vi: { number: '+84', flag: 'vn' },
  en: { number: '+01', flag: 'GB' },
}

export const DEFAULT_LANGUAGE = 'vi'

export const REFERRER_CODE = 'referrer_code'

/**
 * define range for z-index value
 */
export const ZINDEX = {
  HIGHEST: 1000,
  HIGHT: 700,
  MODERATE: 500,
  LOW: 300,
  LOWEST: 100,
}

export const GA_EVENTS = {
  SECONDARY: 'Secondary',
}

// INVESTMENT STEPS
export const VOTING_STEP = 'voting'
export const SPECIFY_SHARES_STEP = 'specify_shares_step'
export const PAYMENT_STEP = 'payment'
export const PROCESSING_STEP = 'processing'
export const COMPLETED_STEP = 'completed'

export const HIGH_GAIN_INDEX = {
  [SPECIFY_SHARES_STEP]: 0,
  [PAYMENT_STEP]: 1,
  [PROCESSING_STEP]: 2,
  [COMPLETED_STEP]: 3,
}
